import { ReturnStatement } from '@angular/compiler';
import { Component, OnInit, effect} from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { IdentifierService } from 'merlin-core';
import {
    CustomerType,
    UserProfileObject,
    UserService,
    ValidatorObj,
} from 'merlin-library';
import { LocalizationService } from 'src/core/utilitites/localization.service';
@Component({
    selector: 'app-figma-bucketlist',
    templateUrl: './figma-bucketlist.component.html',
    styleUrls: ['./figma-bucketlist.component.scss'],
    standalone: false
})
export class FigmaBucketlistComponent implements OnInit {
    @Input() topList: any[];
    @Input() botList: any[];
    @Input() implantselectedItem;
    @Input() enableNumbering = false;
    @Output() botBoxUpdate = new EventEmitter<any>();
    @Output() avaliableIds = new EventEmitter<any>();
    autoSelectData: any;
    @Output() botSelectedItem = new EventEmitter<any>();
    customerTypeDirect: boolean;

    public stringLabels = [
        "label.gb.remove",
        "label.gb.add"
    ]

    public labels: Record<string, string>;

    constructor(
        public identifierService: IdentifierService,
        private userService: UserService,
        private localizationService: LocalizationService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
        this.userService
            .getUserProfile(false)
            .subscribe((userProfile: UserProfileObject) => {
                this.customerTypeDirect =
                    userProfile.customerType === CustomerType.Direct;
            });
    }

    ngOnInit(): void {
        this.translateStrings();
    }

    ngAfterViewChecked() {
        this.autoSelectBotOption();
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    stringify(listToStringify: any[]) {
        return JSON.stringify(listToStringify);
    }

    setTopSelected(e) {
        let options = document.querySelectorAll('.top-option');
        options.forEach((option) => {
            if (
                e.target.getAttribute('value') == option.getAttribute('value')
            ) {
                if (e.target.getAttribute('topSelected') !== null) {
                    if (e.target.getAttribute('topSelected') == 'true') {
                        option.setAttribute('topSelected', 'false');
                    } else {
                        option.setAttribute('topSelected', 'true');
                    }
                } else {
                    option.setAttribute('topSelected', 'true');
                }
            } else if (option.getAttribute('topSelected') == null) {
                option.setAttribute('topSelected', 'false');
            }
        });
    }

    setBotSelected(e, selItem) {
        let options = document.querySelectorAll('.bot-option');
        options.forEach((option) => {
            if (
                e.target.getAttribute('value') == option.getAttribute('value')
            ) {
                if (e.target.getAttribute('botSelected') !== null) {
                    if (e.target.getAttribute('botSelected') == 'true') {
                        option.setAttribute('botSelected', 'false');
                    } else {
                        option.setAttribute('botSelected', 'true');
                    }
                } else {
                    option.setAttribute('botSelected', 'true');
                }
            } else if (option.getAttribute('botSelected') == null) {
                option.setAttribute('botSelected', 'false');
            }
        });
        this.botSelectedItem.emit(e);
    }
    onAddButtonClick() {
        let newTopList = [];
        let options = document.querySelectorAll('.top-option');
        options.forEach((option) => {
            let data = JSON.parse(option.getAttribute('value'));
            let listItem = this.topList.filter((topListItem) => {
                if (data.acctId === topListItem.acctId) {
                    return true;
                } else {
                    return false;
                }
            });
            if (option.getAttribute('topSelected') != 'true') {
                newTopList.push(listItem[0]);
            } else {
                this.botList.push(listItem[0]);
            }
        });
        this.topList = newTopList;
        this.botBoxUpdate.emit(this.botList);
        this.avaliableIds.emit(this.topList);
    }

    onRemoveButtonClick() {
        let optionToAdd = document.querySelector('[botSelected="true"]');
        let optionData = JSON.parse(optionToAdd.getAttribute('value'));
        let newBotList = [];
        let options = document.querySelectorAll('.bot-option');
        if (!optionToAdd || optionData.acctId === -1) {
            return;
        }
        options.forEach((option) => {
            let data = JSON.parse(option.getAttribute('value'));
            let listItem = this.botList.filter((botListItem) => {
                if (data.acctId === botListItem.acctId) {
                    return true;
                } else {
                    return false;
                }
            });
            if (option.getAttribute('botSelected') != 'true') {
                newBotList.push(listItem[0]);
            } else {
                this.topList.push(listItem[0]);
            }
        });
        this.botList = newBotList;
        let sortedTopList = this.topList.sort((a, z) =>
            a.lastName.localeCompare(z.lastName)
        );
        this.botBoxUpdate.emit(this.botList);
        this.avaliableIds.emit(sortedTopList);
    }

    onUpSortClick() {
        let optionToMove = document.querySelector('[botSelected="true"]');
        if (!optionToMove) {
            return;
        }
        let optionData = JSON.parse(optionToMove.getAttribute('value'));

        let currentIndex = this.getObjectIndex(this.botList, optionData);
        if (currentIndex == 0) {
            return;
        }
        let nextIndex = currentIndex - 1;
        let newBotList = JSON.parse(JSON.stringify(this.botList));
        newBotList[currentIndex] = this.botList[nextIndex];
        newBotList[nextIndex] = optionData;

        this.botList = newBotList;
        this.botBoxUpdate.emit(this.botList);

        this.autoSelectData = optionData;
    }

    onDownSortClick() {
        let optionToMove = document.querySelector('[botSelected="true"]');
        if (!optionToMove) {
            return;
        }
        let optionData = JSON.parse(optionToMove.getAttribute('value'));

        let currentIndex = this.getObjectIndex(this.botList, optionData);
        if (currentIndex == this.botList.length - 1) {
            return;
        }
        let nextIndex = currentIndex + 1;
        let newBotList = JSON.parse(JSON.stringify(this.botList));
        newBotList[currentIndex] = this.botList[nextIndex];
        newBotList[nextIndex] = optionData;

        this.botList = newBotList;
        this.botBoxUpdate.emit(this.botList);
        this.autoSelectData = optionData;
    }

    autoSelectBotOption() {
        if (this.autoSelectData != null) {
            let objectsToSelect = document.querySelectorAll('.bot-option');
            objectsToSelect.forEach((opt) => {
                let optData = JSON.parse(opt.getAttribute('value'));
                if (optData.acctId == this.autoSelectData.acctId) {
                    opt.setAttribute('botSelected', 'true');
                }
            });
            this.autoSelectData = null;
        }
    }

    getObjectIndex(list: any[], objectToCheck: any) {
        let currentIndex = -1;
        let finalIndex = null;
        list.forEach((listItem) => {
            currentIndex++;
            if (listItem.acctId == objectToCheck.acctId) {
                finalIndex = currentIndex;
            }
        });
        return finalIndex;
    }
}
